<!--
 * @Author: duanyaqin
 * @Date: 2024-04-26 09:14:41
 * @Description: 入口页
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>
<style>
html {
  font-size: 100px;
}
body {
  margin: 0;
  padding: 0;
}
.el-table-filter .el-table-filter__bottom {
  font-size: 16px !important;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
